export default __webpack_public_path__ + "static/media/reporting_graphic.c7508412.png";